try {
  document.addEventListener("DOMContentLoaded", () => {
    Shopify.product = {};
    Shopify.product.formCartAdd = document.querySelector('form[action$="/cart/add"]');
    console.log("Form found:", Shopify.product.formCartAdd);
    console.log("NFI Options starting!");
    initNFIOptions();
  });

  //================================================================================
  // CART NOTIFICATION (existing UI)
  //================================================================================

  function showCartNotification(cartItems, quantity) {
    const notificationDrawer = document.querySelector("cart-notification-drawer");
    if (!notificationDrawer || !Array.isArray(cartItems)) return;

    notificationDrawer.setAttribute("data-test", "cart-notification");

    const totalCents = cartItems.reduce((sum, item) => sum + item.final_price * quantity, 0);

    const html = `
      <div class="quick-buy-drawer__info">
        ${getCartNotificationBannerHtml()}
        <div class="v-stack gap-4 mt-4" style="max-height: 550px; overflow-y: auto;">
          ${cartItems.map((item) => renderCartNotificationItemHtml(item, quantity)).join("")}
        </div>
        ${getCartNotificationTotalHtml(totalCents)}
        ${getCartNotificationActionsHtml()}
      </div>
    `;

    notificationDrawer.innerHTML = html;
    notificationDrawer.show();
  }

  function getCartNotificationTotalHtml(totalCents) {
    const totalFormatted = (totalCents || 0) / 100;
    return `
      <div class="flex justify-between border-t border-border pt-3 mt-4 text-md">
        <span class="font-semibold">Total</span>
        <span class="font-semibold">$${totalFormatted.toFixed(2)} USD</span>
      </div>
    `;
  }

  function getCartNotificationBannerHtml() {
    return `
      <div class="banner banner--success justify-center">
        <svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="offset-icon icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18">
          <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
          <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
        </svg>
        Added to your cart!
      </div>
    `;
  }

  function getCartNotificationActionsHtml() {
    return `
      <form action="/cart" method="post" class="buy-buttons buy-buttons--compact">
        <a class="button button--secondary" href="/cart">View cart</a>
        <button type="submit" class="button" name="checkout" is="custom-button">
          <div>Checkout</div>
          <span class="button__loader"><span></span><span></span><span></span></span>
        </button>
      </form>
    `;
  }

  function renderCartNotificationItemHtml(item, product_quantity) {
    const { image, product_title, title, final_price, url, properties = {} } = item;

    const priceFormatted = final_price / 100;
    const priceTotalFormatted = (final_price * product_quantity) / 100;

    const imageUrl = image?.startsWith("http") ? image : (image ? `https:${image}` : "");
    const productName = product_title || title || "Product";
    const productUrl = url || "#";

    const priceHtml =
      product_quantity === 1
        ? `<div class="text-subdued">$${priceTotalFormatted.toFixed(2)}</div>`
        : `<div class="text-subdued">$${priceFormatted.toFixed(2)} x ${product_quantity} = $${priceTotalFormatted.toFixed(2)}</div>`;

    const imageHtml = imageUrl
      ? `<img src="${imageUrl}" alt="${productName}" class="quick-buy-drawer__media rounded-xs" width="80" height="80">`
      : `<div class="quick-buy-drawer__media rounded-xs" width="80px" height="80px" style="width: -webkit-fill-available;"></div>`;

    return `
      <div class="quick-buy-drawer__variant text-start h-stack gap-6" data-test="cart-notification-item">
        ${imageHtml}
        <div class="v-stack gap-1">
          <div class="v-stack gap-0.5">
            <a href="${productUrl}" class="bold justify-self-start">${productName}</a>
            ${priceHtml}
            ${renderCartNotificationPropertiesHtml(properties)}
          </div>
        </div>
      </div>
    `;
  }

  function renderCartNotificationPropertiesHtml(properties) {
    return Object
      .entries(properties)
      .filter(([key]) =>
        key !== "SKU" &&
        key !== "HOLSTER-SKU" &&
        key !== "BAG-SKU" &&
        key !== "BundleId" &&
        key != "CHEST-SKU"
      )
      .map(([key, value]) => `<p class="text-sm"><strong>${key}:</strong> ${value}</p>`)
      .join("");
  }

  //================================================================================
  // NFI OPTIONS
  //================================================================================

  // ====== PUBLIC CONTEXT API ======
  window.NFFI_Product = window.NFFI_Product || {};

  window.NFFI_Product.getContext = function () {
    window.NFFI_Product.refreshContext();
    window.NFFI_Product._ctx = getProductContext();
    return window.NFFI_Product._ctx;
  };

  window.NFFI_Product.refreshContext = function () {
    window.NFFI_Product._ctx = getProductContext();
    return window.NFFI_Product._ctx;
  };
  
  document.addEventListener("variant:change", function (event) {
    // Keep the shared variant in sync with the picker (colour swatches, dropdowns).
    // Events fired by another product's form resolve to null and are ignored.
    const selected =
      findVariantById(event?.detail?.variant?.id) || getSelectedVariant();

    if (selected) {
      window.nffi = window.nffi || {};
      window.nffi.product_variant = selected;
    }

    if (window.NFFI_Product && typeof window.NFFI_Product.refreshContext === "function") {
      window.NFFI_Product.refreshContext();
    }
  });

  document.addEventListener("nffi:product:changed", function () {
    if (window.NFFI_Product && typeof window.NFFI_Product.refreshContext === "function") {
      window.NFFI_Product.refreshContext();
    }
  });


  // Cached DOM refs (may be null on products without firearm UI)
  const firearmBrandSelect = document.querySelector(".firearm-options-container #firearm-brand");
  const firearmModelSelect = document.querySelector(".firearm-options-container #firearm-model");
  const holsterColorSelect = document.querySelector(".firearm-options-container #holster-color");
  const handSelect = document.querySelector(".firearm-options-container #firearm-hand");
  const agreementInput = document.querySelector(".firearm-options-container input[name='user-agreement']");

  // error spans
  const brandError = document.querySelector(".firearm-options-container #firearm-brand-error");
  const modelError = document.querySelector(".firearm-options-container #firearm-model-error");
  const holsterError = document.querySelector(".firearm-options-container #holster-color-error");
  const agreementError = document.querySelector(".firearm-options-container #user-agreement-error");

  const PRODUCT_MODES = {
    NONE: "NONE",

    // Legacy single-line bundle product that already includes bag + holster internally
    LEGACY_BUNDLE_BAG_HLST: "LEGACY_BUNDLE_BAG_HLST",

    // Legacy multi-line configurations
    LEGACY_BAG_WITH_HOLSTER: "LEGACY_BAG_WITH_HOLSTER",
    LEGACY_BAG_WITH_ADAPTER: "LEGACY_BAG_WITH_ADAPTER",

    // Simple bag without Bag Options
    STAND_ALONE_BAG: "STAND_ALONE_BAG",

    // Standalone holster page
    STANDALONE_HOLSTER: "STANDALONE_HOLSTER",
    // Chest holster page
    CHEST_HOLSTER: "CHEST_HOLSTER",

    // Bag Options modes (new architecture)
    BAG_OPTIONS_BAG_ONLY: "BAG_OPTIONS_BAG_ONLY",
    BAG_OPTIONS_BAG_WITH_HOLSTER: "BAG_OPTIONS_BAG_WITH_HOLSTER",
    BAG_OPTIONS_BAG_WITH_ADAPTER: "BAG_OPTIONS_BAG_WITH_ADAPTER"
  };

  function initNFIOptions() {
    const ctx = getContext();
    console.log("[NFFI] context:", ctx);

    nfi_bindAddToCartButton();

    // Bag Options UI moved to bag-options.js
    if (window.NFFI_BagOptions && typeof window.NFFI_BagOptions.init === "function") {
      window.NFFI_BagOptions.init();
    }

    initFirearmLogic();
    initProductAddons();
    initDropdownSelectedLabels();
  }

  function initDropdownSelectedLabels() {
    document.querySelectorAll(".dropdown-select").forEach(select => {
      const labelValue = document.querySelector(
        `.dropdown-selected-value[data-for="${select.id}"]`
      );

      if (!labelValue) return;

      const update = () => {
        const option = select.options[select.selectedIndex];
        labelValue.textContent = option && option.value ? `: ${option.text}` : "";
      };

      select.addEventListener("change", update);
      update();
    });
  }

  // ---------------- Addons ----------------

  function initProductAddons() {
    try {
      const addonBlocks = document.querySelectorAll(".addon-block");
      addonBlocks.forEach((block) => {
        const button = block.querySelector(".addon-block__add-button");

        block.addEventListener("click", (e) => {
          // Variant pills manage their own state; a click there must not
          // toggle the whole add-on on or off.
          if (e.target.closest(".addon-block__variants")) return;
          if (button) toggleAddonBlockSelected(block, button);
        });

        if (button) {
          button.addEventListener("click", (e) => {
            e.stopPropagation();
            toggleAddonBlockSelected(block, button);
          });
        }
      });
    } catch (error) {
      console.log("[initProductAddons] - Execution error:", error);
    }
  }

  function toggleAddonBlockSelected(block, button) {
    let selected = block.classList.toggle("selected");
    selected = button.classList.toggle("selected");
    button.textContent = selected ? "– Remove" : "+ Add";

    setTimeout(recalcTotalPrice(), 10);
  }

  // ---------------- Firearm logic ----------------

  function initFirearmLogic() {
    // If firearm block not present on this template, skip.
    if (!firearmBrandSelect || !firearmModelSelect) return;

    firearmBrandSelect.addEventListener("change", () => {
      firearmModelSelect.disabled = !firearmBrandSelect.value;
      firearmModelSelect.value = "";
      clearError(brandError);

      // Reset holster color when brand changes
      if (holsterColorSelect) {
        holsterColorSelect.disabled = true;
        holsterColorSelect.value = "";
        clearError(holsterError);
      }
    });

    firearmModelSelect.addEventListener("change", () => {
      clearError(modelError);
      if (holsterColorSelect) {
        holsterColorSelect.disabled = !firearmModelSelect.value;
        holsterColorSelect.value = "";
      }
      setTimeout(recalcTotalPrice(), 10);
    });

    if (holsterColorSelect) {
      holsterColorSelect.addEventListener("change", () => {
        clearError(holsterError);
        setTimeout(recalcTotalPrice(), 10);
      });
    }

    if (agreementInput) {
      agreementInput.addEventListener("change", () => clearError(agreementError));
    }
  }

  function showError(errorSpan) {
    if (errorSpan) errorSpan.style.display = "inline-block";
  }

  function clearError(errorSpan) {
    if (errorSpan) errorSpan.style.display = "none";
  }

  //================================================================================
  // Product context / Bag Options mode detection
  //================================================================================

  // ---------------- Selected variant ----------------
  function getSelectedVariantId() {
    const input =
      document.querySelector("form.shopify-product-form [name='id']") ||
      document.querySelector('form[action$="/cart/add"] [name="id"]');

    const id = Number(input?.value);
    return Number.isInteger(id) && id > 0 ? id : null;
  }

  function findVariantById(variantId) {
    const product = window.nffi && window.nffi.product;
    const variants = Array.isArray(product?.variants) ? product.variants : [];

    if (!variantId || variants.length === 0) return null;

    return variants.find((v) => Number(v?.id) === Number(variantId)) || null;
  }

  function getSelectedVariant() {
    const fallback = (window.nffi && window.nffi.product_variant) || null;
    return findVariantById(getSelectedVariantId()) || fallback;
  }

  // ---------------- Addon variant matching ----------------

  // Option values are authored by hand in Shopify, so compare them loosely.
  function normalizeOptionValue(value) {
    return String(value == null ? "" : value).trim().toLowerCase();
  }

  // `options` is a list of names on the product ("Size") and a list of values on
  // the variant ("Medium"), aligned by position.
  function getOptionNames(product) {
    const options = Array.isArray(product?.options_with_values)
      ? product.options_with_values
      : Array.isArray(product?.options)
        ? product.options
        : [];

    return options.map((option) => (typeof option === "string" ? option : option?.name || ""));
  }

  function getVariantOptionMap(product, variant) {
    const names = getOptionNames(product);
    const values = Array.isArray(variant?.options)
      ? variant.options
      : [variant?.option1, variant?.option2, variant?.option3];

    const map = new Map();

    values.forEach((value, index) => {
      if (value == null || value === "") return;
      const name = normalizeOptionValue(names[index]) || `option${index + 1}`;
      map.set(name, normalizeOptionValue(value));
    });

    return map;
  }

  /**
   * Picks the variant of an addon product (BAG metafield, ...) that exactly matches the
   * variant the shopper selected on the main product: same values on every option the two
   * products share (Size, Color, ...). Returns null when no exact match exists.
   */
  function findMatchingVariant(addonProduct, sourceProduct, sourceVariant) {
    const variants = Array.isArray(addonProduct?.variants) ? addonProduct.variants : [];
    if (variants.length === 0) return null;

    // Source product has no options configured: nothing to match on, so use the
    // addon's first (and typically only meaningful) variant.
    if (getOptionNames(sourceProduct).length === 0) return variants[0] || null;

    const selectedOptions = getVariantOptionMap(sourceProduct, sourceVariant);
    if (selectedOptions.size === 0) return null;

    const isExactMatch = (candidate) => {
      const candidateOptions = getVariantOptionMap(addonProduct, candidate);
      if (candidateOptions.size !== selectedOptions.size) return false;

      for (const [name, value] of selectedOptions) {
        if (candidateOptions.get(name) !== value) return false;
      }

      return true;
    };

    return variants.find(isExactMatch) || null;
  }

  function getProductContext() {
    const product = window.nffi && window.nffi.product;
    const variant = getSelectedVariant();

    if (!product || !variant) return null;

    const tags = Array.isArray(product.tags) ? product.tags : [];
    const hasTag = (tag) => tags.includes(tag);

    const isLegacyBagWithHolster = hasTag("BAGS WITH HOLSTER");
    const isLegacyBagWithAdapter =
      hasTag("BAGS IWB ADAPTER") || hasTag("BAGS WITH ADAPTER");

    const isBundleBagHlstSingle = hasTag("Bundle-BAG-HLST");
    const isBagTag = hasTag("Bags");
    const isHolsterTag = hasTag("Holsters") || hasTag("Bundle-HLST");
    const isChestHolsterTag = hasTag("Chest-Holster");

    const addons = (window.nffi && window.nffi.product_addons) || {};

    // --- metafields ---

    const bagMeta = addons.BAG || null;

    // The bag product carries the same options as the product on the page, so it follows
    // the variant picker instead of always adding the first variant.
    const bagMetaVariant = findMatchingVariant(bagMeta, product, variant);

    const adapterMeta = addons["IWB Adapter"] || null;
    const adapterMetaVariant =
      adapterMeta &&
      Array.isArray(adapterMeta.variants) &&
      adapterMeta.variants[0]
        ? adapterMeta.variants[0]
        : null;

    const holstersMeta = addons.Holsters || null;
    const holstersMetaVariant =
      holstersMeta &&
      Array.isArray(holstersMeta.variants) &&
      holstersMeta.variants[0]
        ? holstersMeta.variants[0]
        : null;

    const hasAutoProducts =
      Array.isArray(addons.AutoProducts) && addons.AutoProducts.length > 0;

    const isBag =
      isBagTag ||
      isLegacyBagWithHolster ||
      isLegacyBagWithAdapter ||
      isBundleBagHlstSingle;

    const isHolster = isHolsterTag;
    const isChestHolster = isChestHolsterTag;

    const isLegacyBagType =
      isLegacyBagWithHolster || isLegacyBagWithAdapter || isBundleBagHlstSingle;

    const hasBagMeta = !!bagMetaVariant;
    const hasAdapterMeta = !!adapterMetaVariant;
    const hasHolstersMeta = !!holstersMetaVariant;

    // --- UI presence ---

    const hasColorSelectorUI = !!document.querySelector(".product-color-selector");

    const hasBagOptionsUI = !!document.querySelector(
      '.product-info__block-item[data-block-type="bag-options"], .bag-options'
    );

    const hasFirearmOptionsUI = !!document.querySelector(".firearm-options-container");

    
    const bagOptionsEnabled =
      isBag &&
      hasBagOptionsUI;

    const hasVariantChoice =
      Array.isArray(product.variants) && product.variants.length > 1;

    const canUseBagMetaAsMain = !hasColorSelectorUI && hasBagMeta;

    // The BAG metafield should be the main cart line, but none of its variants matches the
    // selected one: options on the two products are out of sync in the admin. Adding to cart
    // must fail loudly instead of silently falling back to the variant of the page product.
    const bagMetaVariantUnresolved =
      !hasColorSelectorUI && hasVariantChoice && !!bagMeta && !bagMetaVariant;

    return {
      product,
      variant,
      tags,
      addons,
      bagMetaVariant,
      adapterMetaVariant,
      hasAutoProducts,
      isBag,
      isHolster,
      isChestHolster,
      isLegacyBagType,
      isLegacyBagWithHolster,
      isLegacyBagWithAdapter,
      isBundleBagHlstSingle,
      isBagTag,
      isHolsterTag,
      bagOptionsEnabled,
      canUseBagMetaAsMain,
      bagMetaVariantUnresolved,
      hasBagOptionsUI,
      hasFirearmOptionsUI
    };
  }

  function getBagConfig() {
    const checked = document.querySelector("input[name='bag-config-ui']:checked");
    return checked ? checked.value : null;
  }

  function getProductMode(ctx) {
    if (!ctx) return PRODUCT_MODES.NONE;

    const {
      isBag,
      isHolster,
      isChestHolster,
      isLegacyBagWithHolster,
      isLegacyBagWithAdapter,
      isBundleBagHlstSingle,
      bagOptionsEnabled
    } = ctx;

    
    // Chest holster product
    if (isChestHolster) {
      return PRODUCT_MODES.CHEST_HOLSTER;
    }
    
    // Pure holster product
    if (isHolster && !isBag) {
      return PRODUCT_MODES.STANDALONE_HOLSTER;
    }

    // Legacy single-line bundle product (bag + holster inside)
    if (isBundleBagHlstSingle && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BUNDLE_BAG_HLST;
    }

    // Legacy bag with holster: 2 lines in cart, no config metafields yet
    if (isLegacyBagWithHolster && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER;
    }

    // Legacy bag with IWB adapter: single combined product until Bag Options are enabled
    if (isLegacyBagWithAdapter && !bagOptionsEnabled) {
      return PRODUCT_MODES.LEGACY_BAG_WITH_ADAPTER;
    }
    
    // Bag Options: any bag (legacy or new) once config metafields are present
    if (isBag && bagOptionsEnabled) {
      const cfg = getBagConfig();
      if (cfg === "BAG_WITH_HOLSTER") {
        return PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER;
      }
      if (cfg === "BAG_WITH_ADAPTER") {
        return PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER;
      }
      return PRODUCT_MODES.BAG_OPTIONS_BAG_ONLY;
    }

    // Simple bag without Bag Options
    if (isBag && !bagOptionsEnabled) {
      return PRODUCT_MODES.STAND_ALONE_BAG;
    }

    return PRODUCT_MODES.NONE;
  }

  function recalcTotalPrice() {
    // Preferred: direct API
    if (window.NFFI_TotalPrice && typeof window.NFFI_TotalPrice.recalc === "function") {
      window.NFFI_TotalPrice.recalc();
      return;
    }

    // Fallback: event-based
    document.dispatchEvent(new CustomEvent("nffi:total:recalc"));
  }

  // ---------------- Add to cart bind ----------------
  function nfi_bindAddToCartButton() {
    try {
      const addToCartButton = document.querySelector("form.shopify-product-form button[type='submit']");
      console.log('nfi_bindAddToCartButton', addToCartButton);
      if (!addToCartButton) return;

      document.addEventListener("submit", async (e) => {
        const form = e.target.closest("form.shopify-product-form");
        if (!form) return;

        console.log("NFI submit captured", form);

        const ctx = getProductContext();
        console.log("ctx", ctx);

        if (!ctx || !ctx.product) return;

        const { isBag, isHolster } = ctx;
        const mode = getProductMode(ctx);

        const isRelevant = isBag || isHolster;
        if (!isRelevant) return;

        
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!validateSelections(ctx)) return;

        const productItems = getProductItems(ctx);
        if (!Array.isArray(productItems) || productItems.length === 0) {
          showAddToCartError({ description: "No items to add. Configuration is incomplete." });
          return;
        }

        const button = e.target.closest("button");
        button?.setAttribute("aria-busy", "true");
        button?.setAttribute("disabled", "disabled");

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ items: productItems }),
          });

          const responseJson = await response.json().catch(() => ({}));

          button?.setAttribute("aria-busy", "false");
          button?.removeAttribute("disabled");

          if (response.ok) {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            showCartNotification(responseJson.items, getQuantity());
            return;
          }

          showAddToCartError(responseJson);

          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: { error: responseJson.description || responseJson.message || "Cart Error" }
          }));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } catch (err) {
          button?.setAttribute("aria-busy", "false");
          button?.removeAttribute("disabled");
          console.error("Add to cart error:", err);
          showAddToCartError({ description: "Something went wrong. Please try again." });
        }
      }, true);
    } catch (error) {
      console.log("[nfi_bindAddToCartButton] - Execution error:", error);
    }
  }

  function showAddToCartError(payload) {
    const desc = payload?.description || payload?.message || "Cart Error";
    if ((desc || "").toLowerCase().includes("cannot find variant")) {
      console.error("[Cart Error] Cannot find variant. Likely: empty/wrong variant id in items[]");
    } else {
      console.error("[Cart Error]", payload);
    }
    alert(desc);
  }

  // ---------------- Build items ----------------

  function getProductItems(ctx) {
    if (!ctx) return [];

    const {
      product,
      variant,
      addons,
      bagMetaVariant,
      adapterMetaVariant,
      hasAutoProducts,
      isBag,
      isHolster,
      isBundleBagHlstSingle,
      bagOptionsEnabled
    } = ctx;

    const quantity = getQuantity();
    const mode = getProductMode(ctx);

    // Decide which variant is the main "bag" / main product line:
    // - If we are allowed to use BAG metafield -> use it.
    // - Otherwise -> use current product variant.
    const mainVariant = ctx.bagMetaVariantUnresolved
      ? null
      : ctx.canUseBagMetaAsMain && bagMetaVariant
        ? bagMetaVariant
        : variant;

    const mainId = Number(mainVariant?.id);
    const mainSKU = mainVariant?.sku || "";

    if (!Number.isInteger(mainId) || mainId <= 0) {
      alert("This product configuration is currently unavailable. Please refresh the page.");

      if (ctx.bagMetaVariantUnresolved) {
        console.error("[getProductItems] No BAG metafield variant matches the selected options:", {
          selected: variant?.title,
          bag: addons.BAG?.handle || addons.BAG?.title
        });
      } else {
        console.error("[getProductItems] Main variant id is missing/invalid:", mainVariant);
      }

      return [];
    }

    if (mainVariant.available === false) {
      alert("This product is currently out of stock. Please choose another configuration.");
      console.warn("[getProductItems] Main variant unavailable:", {
        id: mainVariant.id,
        sku: mainVariant.sku
      });
      return [];
    }

    const mainProperties = {};

    if (bagOptionsEnabled) {
      const cfg = getBagConfig();
      if(cfg) {
       mainProperties["Bag configuration"] = cfg;
      }
    }

    // Determine if we need a bundleId:
    // Bundle means: bag + holster or bag + adapter or AutoProducts.
    const isBundleMode =
      mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER ||
      mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER ||
      mode === PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER ||
      mode === PRODUCT_MODES.LEGACY_BAG_WITH_ADAPTER ||
      mode === PRODUCT_MODES.CHEST_HOLSTER ||
      ctx.hasAutoProducts;

    const bundleId = isBundleMode
      ? `BAGCFG-${Date.now()}-${Math.random().toString(16).slice(2)}`
      : null;

    if (bundleId) {
      mainProperties["BundleId"] = bundleId;
    }

    const productItems = [{
      id: mainId,
      quantity,
      properties: mainProperties
    }];

    // ============================================================
    // 1) SPECIAL CASE: Bundle-BAG-HLST (single cart line + firearm props)
    // ============================================================
    if (mode === PRODUCT_MODES.LEGACY_BUNDLE_BAG_HLST) {
      mainProperties["Firearm hand"] = getSelectedFirearmHandText();
      mainProperties["Firearm brand"] = getSelectedFirearmBrand();
      mainProperties["Firearm model"] = getSelectedFirearmModel();
      return productItems;
    }

    // ============================================================
    // 2.1) Standalone holster page
    // ============================================================
    if (mode === PRODUCT_MODES.STANDALONE_HOLSTER) {
      mainProperties["SKU"] = buildHolsterSKU(variant.sku);
      mainProperties["Firearm hand"] = getSelectedFirearmHandText();
      mainProperties["Firearm model"] = getSelectedFirearmModel();
    }

    // ============================================================
    // 2.2) Chest holster page
    // ============================================================
    if (mode === PRODUCT_MODES.CHEST_HOLSTER) {

      const holsterId = getSelectedHolsterId();
      const holsterSku = getSelectedHolsterSKU();
      const fullHolsterSku = buildHolsterSKU(holsterSku);

      mainProperties["Holster color"] = getSelectedHolsterColor();
      mainProperties["HOLSTER-SKU"] = fullHolsterSku;

      if (holsterId) {
        productItems.push({
          id: parseInt(holsterId, 10),
          quantity,
          properties: {
            ...(bundleId ? { BundleId: bundleId } : {}),
            "SKU": fullHolsterSku,
            "CHEST-SKU": mainSKU,
            "Firearm hand": getSelectedFirearmHandText(),
            "Firearm model": getSelectedFirearmModel()
          }
        });
      }

    }

    // ============================================================
    // 3) Legacy BAGS IWB ADAPTER: 2 products (bag + adapter) or fallback single-line product (no adapter split)
    // ============================================================
    if (mode === PRODUCT_MODES.LEGACY_BAG_WITH_ADAPTER) {
      //2 products (bag + adapter)
      if (ctx.canUseBagMetaAsMain 
        && bagMetaVariant 
        && bagMetaVariant.available !== false 
        && adapterMetaVariant 
        && adapterMetaVariant.available !== false) {

        let adapterId = adapterMetaVariant.id;
        let adapterSku = adapterMetaVariant.sku || "";
      
        productItems.push({
          id: parseInt(adapterId, 10),
          quantity,
          properties: {
            ...(bundleId ? { BundleId: bundleId } : {}),
            "BAG-SKU": mainSKU,
            "SKU": adapterSku || ""
          }
        });        
      }
      // fallback single-line product (no adapter split)
    }

    // ============================================================
    // 4) Bag Options - BAG_WITH_ADAPTER (new behavior: bag + adapter)
    // ============================================================
    if (mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER) {
      let adapterId = document.querySelector("#selected-adapter-id")?.value || "";
      let adapterSku = document.querySelector("#selected-adapter-sku")?.value || "";

      // Fallback to metafields (IWB Adapter) if UI didn't provide a specific variant.
      if (!adapterId && adapterMetaVariant && adapterMetaVariant.available !== false) {
        adapterId = adapterMetaVariant.id;
        adapterSku = adapterMetaVariant.sku || "";
      }

      if (adapterId) {
        productItems.push({
          id: parseInt(adapterId, 10),
          quantity,
          properties: {
            ...(bundleId ? { BundleId: bundleId } : {}),
            "BAG-SKU": mainSKU,
            "SKU": adapterSku || ""
          }
        });
      }
    }

    // ============================================================
    // 5) Bags - BAG_WITH_HOLSTER (legacy + Bag Options)
    // ============================================================
    if (
      mode === PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER ||
      mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER
    ) {
      const holsterId = getSelectedHolsterId();
      const holsterSku = getSelectedHolsterSKU();
      const fullHolsterSku = buildHolsterSKU(holsterSku);

      mainProperties["Holster color"] = getSelectedHolsterColor();
      mainProperties["HOLSTER-SKU"] = fullHolsterSku;

      if (holsterId) {
        productItems.push({
          id: parseInt(holsterId, 10),
          quantity,
          properties: {
            ...(bundleId ? { BundleId: bundleId } : {}),
            "SKU": fullHolsterSku,
            "BAG-SKU": mainSKU,
            "Firearm hand": getSelectedFirearmHandText(),
            "Firearm model": getSelectedFirearmModel()
          }
        });
      }
    }

    // ============================================================
    // 6) AutoProducts: always join the bundle if present
    // ============================================================
    if (hasAutoProducts) {
      addons.AutoProducts.forEach((item) => {
        const variants = Array.isArray(item.variants) ? item.variants : [];
        const autoVariant = variants[0];
        if (!autoVariant || !autoVariant.available) return;

        productItems.push({
          id: parseInt(autoVariant.id, 10),
          quantity,
          properties: bundleId ? { BundleId: bundleId } : {}
        });
      });
    }

    // ============================================================
    // 7) Selected addon blocks: NOT part of bundle
    // ============================================================
    document.querySelectorAll(".addon-block.selected").forEach(block => {
      const addonId = block.getAttribute("data-addon-id");
      if (!addonId) return;

      productItems.push({
        id: parseInt(addonId, 10),
        quantity,
        properties: {}
      });
    });

    return productItems;
  }

  // ---------------- Validation ----------------

  function validateSelections(ctx) {
    let valid = true;
    let firstInvalidElement = null;
console.log('validateSelections', ctx);
    if (!ctx || !ctx.product) return true;

    const {
      isBag,
      isHolster,
      isBundleBagHlstSingle,
      isLegacyBagWithHolster,
      isLegacyBagWithAdapter,
      bagOptionsEnabled
    } = ctx;

    const mode = getProductMode(ctx);

    function markInvalid(el, errorSpan) {
      if (errorSpan) showError(errorSpan);
      valid = false;
      if (!firstInvalidElement) firstInvalidElement = el || errorSpan;
    }

    function clearIfExists(errorSpan) {
      if (errorSpan) clearError(errorSpan);
    }

    function isInvalidSelectValue(selectEl) {
      if (!selectEl) return false;
      const value = (selectEl.value || "").trim();
      if (!value) return true;

      const text = (selectEl.options?.[selectEl.selectedIndex]?.text || "").trim().toLowerCase();
      if (text === "select brand" || text === "select model" || text === "select color") return true;

      return false;
    }

    // Detect magnetic pre-order bag
    const isMagneticPreorder = !!document.querySelector(".magnetic-preorder-container");

    // Bag configuration must be selected only when Bag Options are enabled
    // (skip this check entirely on magnetic pre-order bag)
    if (
      isBag &&
      bagOptionsEnabled &&
      !isBundleBagHlstSingle &&
      !isLegacyBagWithHolster &&
      !isLegacyBagWithAdapter &&
      !isMagneticPreorder
    ) {
      const cfg = getBagConfig();
      if (!cfg) {
        valid = false;
        if (window.NFFI_BagOptions && typeof window.NFFI_BagOptions.showBagConfigError === "function") {
          window.NFFI_BagOptions.showBagConfigError(
            "Please choose how you’ll carry before adding this bag to your cart."
          );
        }
        if (!firstInvalidElement) {
          firstInvalidElement = document.querySelector(".bag-config") || document.body;
        }

        if (!valid && firstInvalidElement) {
          firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return valid;
      } else if (window.NFFI_BagOptions && typeof window.NFFI_BagOptions.clearBagConfigError === "function") {
        window.NFFI_BagOptions.clearBagConfigError();
      }
    } else {
      if (window.NFFI_BagOptions && typeof window.NFFI_BagOptions.clearBagConfigError === "function") {
        window.NFFI_BagOptions.clearBagConfigError();
      }
    }

    // User agreement
    if (agreementInput) {
      const isAgreementRequired = agreementInput.hasAttribute("required");

      const shouldValidateAgreement =
        isAgreementRequired && (
          isHolster ||
          isLegacyBagWithHolster ||
          isBundleBagHlstSingle ||
          isMagneticPreorder ||
          (isBag && mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER)
        );

      if (shouldValidateAgreement) {
        if (!agreementInput.checked) {
          showError(agreementError);
          valid = false;

          const visibleTarget =
            agreementInput.closest(".firearm-dropdowns") ||
            agreementError ||
            document.querySelector("#holster-options") ||
            agreementInput;

          if (!firstInvalidElement) firstInvalidElement = visibleTarget;
        } else {
          clearError(agreementError);
        }
      } else {
        clearError(agreementError);
      }
    }

    // HOLSTER pages: always require firearm brand+model (+color if exists)
    if (mode === PRODUCT_MODES.STANDALONE_HOLSTER || mode === PRODUCT_MODES.CHEST_HOLSTER) {
      if (firearmBrandSelect && isInvalidSelectValue(firearmBrandSelect)) markInvalid(firearmBrandSelect, brandError);
      else clearIfExists(brandError);

      if (firearmModelSelect && isInvalidSelectValue(firearmModelSelect)) markInvalid(firearmModelSelect, modelError);
      else clearIfExists(modelError);

      if (holsterColorSelect) {
        if (isInvalidSelectValue(holsterColorSelect)) markInvalid(holsterColorSelect, holsterError);
        else clearIfExists(holsterError);
      }      
    }

    // Bundle-BAG-HLST single product: require firearm brand+model (+hand)
    if (mode === PRODUCT_MODES.LEGACY_BUNDLE_BAG_HLST) {
      if (handSelect) {
        if (!(handSelect.value || "").trim()) markInvalid(handSelect, null);
      }

      if (firearmBrandSelect && isInvalidSelectValue(firearmBrandSelect)) markInvalid(firearmBrandSelect, brandError);
      else clearIfExists(brandError);

      if (firearmModelSelect && isInvalidSelectValue(firearmModelSelect)) markInvalid(firearmModelSelect, modelError);
      else clearIfExists(modelError);
    }

    // Bags: validate depending on mode (new flow + legacy holster)
    // (skip these checks entirely on magnetic pre-order bag)
    if (isBag && !isBundleBagHlstSingle && !isMagneticPreorder) {
      if (mode === PRODUCT_MODES.BAG_OPTIONS_BAG_ONLY || mode === PRODUCT_MODES.STAND_ALONE_BAG) {
        // no extra validation
      }

      if (mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_ADAPTER) {
        const adapterId = document.querySelector("#selected-adapter-id")?.value || "";
        if (!adapterId && !ctx.adapterMetaVariant) {
          valid = false;
          if (!firstInvalidElement) {
            firstInvalidElement = document.querySelector("#adapter-options") || agreementInput;
          }
        }
      }

      if (mode === PRODUCT_MODES.LEGACY_BAG_WITH_HOLSTER || mode === PRODUCT_MODES.BAG_OPTIONS_BAG_WITH_HOLSTER) {
        if (handSelect) {
          if (!(handSelect.value || "").trim()) markInvalid(handSelect, null);
        }

        if (firearmBrandSelect && isInvalidSelectValue(firearmBrandSelect)) markInvalid(firearmBrandSelect, brandError);
        else clearIfExists(brandError);

        if (firearmModelSelect && isInvalidSelectValue(firearmModelSelect)) markInvalid(firearmModelSelect, modelError);
        else clearIfExists(modelError);

        if (holsterColorSelect) {
          if (isInvalidSelectValue(holsterColorSelect)) markInvalid(holsterColorSelect, holsterError);
          else clearIfExists(holsterError);
        }

        const holsterId = getSelectedHolsterId();
        if (!holsterId) {
          valid = false;
          if (!firstInvalidElement) {
            firstInvalidElement =
              document.querySelector("#holster-options") || firearmModelSelect || holsterColorSelect;
          }
        }
      }
    }

    if (!valid && firstInvalidElement) {
      firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    return valid;
  }

  //================================================================================
  // Helpers
  //================================================================================

  function buildHolsterSKU(baseSKU) {
    const handSKU = getSelectedFirearmHand() || "";
    const firearmModelSKU = getSelectedFirearmModelSKU() || "";
    return `${baseSKU}-${handSKU}-${firearmModelSKU}`;
  }

  function getUserAgreementLabel() {
    const agreementLabel = document.querySelector('label[for="user-agreement"].dropdown-label');
    return agreementLabel;
  }

  function getUserAgreementLabelText() {
    const agreementLabel = getUserAgreementLabel();
    return agreementLabel ? agreementLabel.textContent.trim() : "";
  }

  function getUserAgreementButtonText() {
    const buttonLabel = document.querySelector('label[for="user-agreement"].radio-button');
    return buttonLabel ? buttonLabel.textContent.trim() : "";
  }

  function getSelectedFirearmHand() {
    return document.querySelector("#firearm-hand")?.value || "";
  }

  // data-label survives browser auto-translate, which rewrites option text.
  function getSelectedOptionLabel(el) {
    const option = el?.options[el.selectedIndex];
    return option ? option.dataset.label || option.text || "" : "";
  }

  function getSelectedFirearmHandText() {
    return getSelectedOptionLabel(document.querySelector("#firearm-hand"));
  }

  function getSelectedFirearmBrand() {
    return getSelectedOptionLabel(document.querySelector("#firearm-brand"));
  }

  function getSelectedFirearmModel() {
    return getSelectedOptionLabel(document.querySelector("#firearm-model"));
  }

  function getSelectedFirearmModelSKU() {
    return document.querySelector("#firearm-model")?.value || "";
  }

  function getSelectedHolsterColor() {
    return document.querySelector("#holster-color")?.value || "";
  }

  function getSelectedHolsterId() {
    return document.querySelector(".firearm-options-container input#selected-holster-id")?.value || "";
  }

  function getSelectedHolsterSKU() {
    return document.querySelector(".firearm-options-container input#selected-holster-sku")?.value || "";
  }

  function getQuantity() {
    const quantityInput = document.querySelector("quantity-selector input[type='number']");
    return quantityInput ? parseInt(quantityInput.value, 10) : 1;
  }

} catch (error) {
  console.log("Execution error:", error);
}